import styled from '@emotion/styled';

const Styles = styled.footer({
});

export default Styles;
